import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCards = ({ stats, className = '' }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const formatPercentage = (value) => {
    return `${value > 0 ? '+' : ''}${value?.toFixed(1)}%`;
  };

  const getChangeColor = (change) => {
    if (change > 0) return 'text-success';
    if (change < 0) return 'text-error';
    return 'text-text-secondary';
  };

  const getChangeIcon = (change) => {
    if (change > 0) return 'TrendingUp';
    if (change < 0) return 'TrendingDown';
    return 'Minus';
  };

  const cardData = [
    {
      title: 'Total Inventory',
      value: stats?.totalItems,
      change: stats?.totalItemsChange,
      icon: 'Package',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Total Value',
      value: formatCurrency(stats?.totalValue),
      change: stats?.totalValueChange,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      title: 'Underpriced Items',
      value: stats?.underpricedItems,
      change: stats?.underpricedItemsChange,
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'Active Alerts',
      value: stats?.activeAlerts,
      change: stats?.activeAlertsChange,
      icon: 'Bell',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ${className}`}>
      {cardData?.map((card, index) => (
        <div key={index} className="bg-surface border border-border rounded-lg shadow-card p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${card?.bgColor}`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
            <div className="text-right">
              <div className={`flex items-center space-x-1 text-sm ${getChangeColor(card?.change)}`}>
                <Icon name={getChangeIcon(card?.change)} size={14} />
                <span>{formatPercentage(card?.change)}</span>
              </div>
              <div className="text-xs text-text-secondary">vs last month</div>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-text-primary mb-1">
              {card?.value}
            </h3>
            <p className="text-sm text-text-secondary">{card?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsCards;